import type { Component } from '~/types';
import { fetchMultipleResource, fetchSingleResource } from '~/units/core/managers';
import { fetchBlog, fetchBlogs, fetchSpecificBlogs } from '~/units/blogs/services';
import { LoadingStates, RepoStates } from '~/units/core/types';
import { useDataFromState, useVariant } from '~/composables/index';

export const fetchBlogsManager = async (component: Component, keyword: string | null = null) => {
  await fetchMultipleResource(component, fetchBlogs, RepoStates.BLOGS_REPO, { keyword });
};

export const fetchBlogManager = async (component: Component, slug: string) => {
  await fetchSingleResource(component, fetchBlog, RepoStates.SINGLE_BLOG_REPO, slug);
};

/**
 * Fetch specific blogs by their slugs (manual selection)
 * @param component Component configuration
 * @param slugs Array of blog slugs to fetch
 */
export const fetchManualBlogsManager = async (component: Component, slugs: string[]) => {
  const { setData, replaceData: setLoading, data } = useDataFromState(LoadingStates.IS_MANUAL_BLOGS_LOADING);
  const { setData: setBlogsData, data: blogsData } = useDataFromState(RepoStates.MANUAL_BLOGS_REPO);

  setLoading(true);

  try {
    const variant = useVariant(component);
    // Build identifier using a sorted copy to avoid mutating input order
    const identifier = `${variant}-${[...slugs].sort().join('-')}`;

    // Check if already in state
    const existingData = blogsData ? blogsData.find((item: any) => item.identifier === identifier) : null;

    if (!existingData) {
      const result = await fetchSpecificBlogs(slugs);

      setBlogsData([
        {
          data: result.data,
          total: result.total,
          query: {
            slugs,
          },
          identifier,
        },
      ]);
    }
  } catch (e) {
    // Silently handle errors
  }

  setLoading(false);
};
